import { Button, Grid } from '@design-systems/canvas-ui'
import { useState } from 'react'
import { Table } from 'components/table-compat/table-compat'
import { TableData, buildDataTableObject } from 'utils/data'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { useEssentials } from 'hooks/utils/useEssentials'

type TitledFilteredTableProps = {
    title: string
    data: TableData
    widths: number[]
    selectedCell?: string
    handleClick?: (value: string) => void
    pinFirstColumn?: boolean
    isLoading?: boolean
    filterTranslation?: {
        viewInDollars: string
        viewInPercent: string
    }
}

export const TitledFilteredTable = ({
    title,
    data,
    widths,
    handleClick,
    pinFirstColumn,
    selectedCell,
    isLoading,
    filterTranslation,
}: TitledFilteredTableProps) => {
    const { t } = useEssentials()
    const filters = filterTranslation ?? TRANSLATION_KEYS.filters
    let derivedData = { ...data }
    const options = ['$', '%']
    const [currentIndex, setCurrentIndex] = useState(0)
    const selectedOption = options[currentIndex]
    const handleToggle = () => setCurrentIndex((prevIndex) => 1 - prevIndex)

    derivedData.headings = derivedData.headings
        ?.filter((r, i) => i === 0 || r.value.includes(selectedOption))
        .map((heading) => {
            return { ...heading, value: heading.value }
        })
    derivedData.rows = derivedData.rows?.map((row) => {
        return row.filter(
            (cell, index) => index === 0 || cell.value.includes(selectedOption),
        )
    })
    derivedData.footer = derivedData.footer
        ?.filter((r, i) => i === 0 || r.value.includes(selectedOption))
        .map((footer) => {
            return { ...footer, value: footer.value }
        })

    const viewLabel = t(
        currentIndex === 0 ? filters.viewInPercent : filters.viewInDollars,
    )

    return (
        <>
            <Grid.Item
                className="hc8-pb-none"
                size={{
                    xs: 7,
                }}
            >
                <p className="hc8-pa-1x hc8-lh-body">{title}</p>
            </Grid.Item>
            <Grid.Item
                className="hc8-pb-none hc8-ta-right"
                size={{
                    xs: 5,
                }}
            >
                <Button onClick={handleToggle} variant="ghost">
                    {viewLabel}
                </Button>
            </Grid.Item>
            <Grid.Item
                className="hc8-pt-none"
                size={{
                    xs: 12,
                }}
            >
                <Table
                    data={buildDataTableObject({
                        currentData: derivedData,
                        widths,
                        handleClick,
                        pinFirstColumn,
                        selectedCell,
                        isLoading,
                    })}
                    name={title}
                    scrollableWidth={true}
                />
            </Grid.Item>
        </>
    )
}
